import {useEffect, useState} from 'react';
import {Amplify} from 'aws-amplify';
import {
    getCurrentUser,
    fetchAuthSession,
    signInWithRedirect,
    signOut,
} from '@aws-amplify/auth';
import awsExports from './aws-exports';
import {jwtDecode} from "jwt-decode";

Amplify.configure(awsExports);

function App() {
    const [user, setUser] = useState(null);
    const [tokens, setTokens] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        async function loadUser() {
            try {
                const currentUser = await getCurrentUser();
                const session = await fetchAuthSession();

                const idToken = session.tokens?.idToken?.toString();
                const accessToken = session.tokens?.accessToken?.toString();
                const refreshToken = session.tokens?.refreshToken?.toString();

                const idPayload = jwtDecode(idToken);

                setUser({
                    username: currentUser.username,
                    email: idPayload.email,
                    sub: idPayload.sub,
                    exp: new Date(idPayload.exp * 1000).toLocaleString(),
                });

                setTokens({idToken, accessToken, refreshToken});
            } catch {
                setUser(null);
            } finally {
                setLoading(false);
            }
        }

        loadUser();
    }, []);

    const handleLogin = () => {
        signInWithRedirect(); // Hosted UI SSO
    };

    const handleLogout = () => {
        signOut({global: true});
    };

    if (loading)
        return (
            <div className="App" style={{
                position: 'absolute',
                top: '37%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                textAlign: 'center'
            }}>
                <p>Loading...</p>
            </div>
        );

    return (
        <div className="App" style={{
            position: 'absolute',
            top: '37%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            textAlign: 'center'
        }}>
            {user ? (
                <>
                    <h1>Dashboard</h1>
                    <p><strong>Username:</strong> {user.username}</p>
                    <p><strong>Email:</strong> {user.email}</p>
                    <p><strong>User ID:</strong> {user.sub}</p>
                    <p><strong>Token Expires:</strong> {user.exp}</p>
                    <p><a href="http://localhost:8080/ctcsWEB/oauth2/authorization/cognito">HTTP</a></p>
                    <p><a href="https://localhost:8443/ctcsWEB/oauth2/authorization/cognito">HTTPS</a></p>
                    <br/>
                    <h3>Tokens (for debugging only):</h3>
                    <pre style={{maxWidth: '100%', overflowX: 'scroll', background: '#f4f4f4', padding: '1em'}}>
                        {JSON.stringify(tokens, null, 2)}
                    </pre>

                    <button onClick={handleLogout}>Sign Out</button>
                </>
            ) : (
                <>
                    <h1>Please Sign In</h1>
                    <button
                        onClick={handleLogin}
                        style={{
                            padding: '10px 20px',
                            fontSize: '16px',
                            backgroundColor: '#000000',
                            color: 'white',
                            border: 'none',
                            borderRadius: '4px',
                            cursor: 'pointer'
                        }}
                    >
                        Sign In with SSO
                    </button>
                </>
            )}
        </div>
    );
}

export default App;